

<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>



              <CForm >
                <h1>Confirmation</h1>
                <p class="text-muted">Sign In to your account</p>
                <CInput
                  placeholder="Username"
                  autocomplete="username email"
                  v-model="username"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  placeholder="確認コード"
                  type="password"
                  autocomplete="curent-password"
                  v-model="confirmationCode"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>

                <CRow>
                  <CCol col="12" class="text-center">
                    <CButton @click="confirm" color="primary" class="px-4">Login</CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>

</template>

<script>

export default {
  name: 'Home',
  components: {},
  data() {
    return {
      username: '',
      confirmationCode: ''
    }
  },
  methods: {
    confirm () {
      this.$cognito.confirmation(this.username, this.confirmationCode)
        .then(result => {
          console.log(result)
          this.$router.replace('/login')
        })
        .then(err => {
          this.error = err
        })
    }

  },
  mounted() {

  }
}
</script>
